import { useMediaQuery } from '@mui/material';

// This page lives on two very different machines: a phone at the rail and the PC in the office,
// which is where it is mostly used. 1024 px is the cut — below it the phone column, above it a real
// two-column desk layout. Not MUI's md/lg, because those are 900/1200 and the owner's call was 1024.
export const DESKTOP_QUERY = '(min-width:1024px)';
export const WIDE_QUERY = '(min-width:1440px)';

export interface Layout {
  desktop: boolean;
  wide: boolean;
}

export function useLayout(): Layout {
  const desktop = useMediaQuery(DESKTOP_QUERY, { noSsr: true });
  const wide = useMediaQuery(WIDE_QUERY, { noSsr: true });
  return { desktop, wide };
}
